import { EChannel } from 'core/model/enums/channel.enum';
import { CHANNEL_CONTACTS } from './contact.constants';

export const WHATSAPP_API_URL = 'https://api.whatsapp.com/send/';

/**
 * Builds WhatsApp link with phone and message
 */
export const buildWhatsAppLink = (phone: string, message: string): string => {
  const encodedMessage = encodeURIComponent(message);
  return `${WHATSAPP_API_URL}?phone=${phone}&text=${encodedMessage}&type=phone_number&app_absent=0`;
};

/**
 * WhatsApp links by channel
 */
export const WHATSAPP_LINKS: Record<EChannel, string> = {
  [EChannel.DIADIA]: buildWhatsAppLink(
    CHANNEL_CONTACTS[EChannel.DIADIA].whatsapp,
    CHANNEL_CONTACTS[EChannel.DIADIA].messageWsp,
  ),
  [EChannel.INSUMA]: buildWhatsAppLink(
    CHANNEL_CONTACTS[EChannel.INSUMA].whatsapp,
    CHANNEL_CONTACTS[EChannel.INSUMA].messageWsp,
  ),
  [EChannel.ALICORP]: buildWhatsAppLink(
    CHANNEL_CONTACTS[EChannel.ALICORP].whatsapp,
    CHANNEL_CONTACTS[EChannel.ALICORP].messageWsp,
  ),
};

/**
 * Gets WhatsApp link for specific channel
 */
export const GET_WHATSAPP_LINK = (channel: EChannel): string => WHATSAPP_LINKS[channel];
